import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Weet u het zeker?',
    },
    [OrderMethod.Pickup]: 'Heeft de klant de bestelling al opgehaald?',
    [OrderMethod.OnSite]: 'Heeft de klant de bestelling al opgehaald?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'Is de bestelling al bezorgd?',
      [DeliveryProvider.UberDrive]: 'Heeft de chauffeur de bestelling al opgehaald?',
      [DeliveryProvider.FirstDelivery]: 'Heeft de chauffeur de bestelling al opgehaald?',
      [DeliveryProvider.WoltDrive]: 'Heeft de chauffeur de bestelling al opgehaald?',
    },
  },
  buttons: {
    cancel: 'Nee, annuleren',
    confirm: 'Ja',
  },
};
